import React from 'react'
import styled from 'styled-components'

import { ListItem } from 'components/Molecules'

import { ListContainer, ListContent } from './index'

const Item = styled(ListItem)`
  flex: 0 100%;
  min-width: 0;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    flex: 0 1 48%;
  }
`

const LoadingSkeleton = () => (
  <ListContainer>
    <ListContent>
      <Item isLoading />
      <Item isLoading />
      <Item isLoading />
      <Item isLoading />
      <Item isLoading />
      <Item isLoading />
    </ListContent>
  </ListContainer>
)

export default LoadingSkeleton
